import { z } from 'zod';
// ---------- F17 Presupuestos ----------
export const QuoteStatusSchema = z.enum([
    'BORRADOR',
    'ENVIADO',
    'EN_NEGOCIACION',
    'ACEPTADO',
    'RECHAZADO',
    'CADUCADO',
    'FACTURADO',
]);
export const QuoteStatusLabel = {
    BORRADOR: 'Borrador',
    ENVIADO: 'Enviado',
    EN_NEGOCIACION: 'En negociación',
    ACEPTADO: 'Aceptado',
    RECHAZADO: 'Rechazado',
    CADUCADO: 'Caducado',
    FACTURADO: 'Facturado',
};
const decimalString = z
    .union([z.number(), z.string()])
    .transform((v) => (typeof v === 'number' ? v.toString() : v));
// ---------- Líneas ----------
export const QuoteLineInputSchema = z.object({
    position: z.number().int().min(0).default(0),
    /** F35 — opcional: producto del catálogo del que se prellenan description/unitPriceCents/vatRate si no se especifican. */
    productId: z.string().nullable().optional(),
    /** Requerido salvo que llegue productId (entonces se hereda del catálogo). */
    description: z.string().min(1).max(500).optional(),
    quantity: decimalString.default('1'),
    /** Requerido salvo que llegue productId. */
    unitPriceCents: z.number().int().optional(),
    /** Coste interno por unidad (mismo criterio que unitPriceCents). Campo interno (margen). */
    costCents: z.number().int().min(0).default(0),
    discountPct: decimalString.default('0'),
    /** Requerido salvo que llegue productId. */
    vatRate: decimalString.optional(),
    isSupplied: z.boolean().default(false),
});
export const QuoteLineDtoSchema = z.object({
    id: z.string(),
    productId: z.string().nullable(),
    position: z.number().int(),
    description: z.string(),
    quantity: decimalString,
    unitPriceCents: z.number().int(),
    costCents: z.number().int(),
    discountPct: decimalString,
    vatRate: decimalString,
    isSupplied: z.boolean(),
    subtotalCents: z.number().int(),
    vatCents: z.number().int(),
    totalCents: z.number().int(),
});
// ---------- CRUD ----------
export const CreateQuoteSchema = z.object({
    clientId: z.string(),
    opportunityId: z.string().nullable().optional(),
    title: z.string().max(300).nullable().optional(),
    notes: z.string().max(4000).nullable().optional(),
    internalNotes: z.string().max(4000).nullable().optional(),
    issueDate: z.string().datetime().optional(),
    validUntil: z.string().datetime().nullable().optional(),
    irpfRate: decimalString.default('0'),
    lines: z.array(QuoteLineInputSchema).default([]),
});
export const UpdateQuoteSchema = CreateQuoteSchema.partial();
/** Transiciones manuales de estado permitidas desde la UI. */
export const QuoteTransitionSchema = z.object({
    action: z.enum(['ACEPTAR', 'RECHAZAR', 'MARCAR_ENVIADO']),
});
export const SendQuoteEmailSchema = z.object({
    /** Destinatario; por defecto, el email del cliente. */
    to: z.string().email().optional(),
    /** Texto adicional para el cuerpo del mensaje. */
    message: z.string().max(4000).optional(),
});
// ---------- DTOs ----------
export const QuoteListItemSchema = z.object({
    id: z.string(),
    number: z.string(),
    status: QuoteStatusSchema,
    issueDate: z.string(),
    validUntil: z.string().nullable(),
    clientId: z.string(),
    clientDisplayName: z.string(),
    opportunityId: z.string().nullable(),
    opportunityCode: z.string().nullable(),
    title: z.string().nullable(),
    totalCents: z.number().int(),
    sentAt: z.string().nullable(),
    invoiceId: z.string().nullable(),
});
export const QuoteDetailSchema = QuoteListItemSchema.extend({
    notes: z.string().nullable(),
    internalNotes: z.string().nullable(),
    subtotalCents: z.number().int(),
    discountCents: z.number().int(),
    vatCents: z.number().int(),
    irpfCents: z.number().int(),
    irpfRate: z.string(),
    /** Coste interno total del documento (suma de costCents × cantidad por línea). Interno, nunca se muestra al cliente. */
    totalCostCents: z.number().int(),
    /** Margen interno = base imponible − totalCostCents. Interno. */
    marginCents: z.number().int(),
    /** Margen en % sobre la base imponible. Interno. */
    marginPct: z.number(),
    sentTo: z.string().nullable(),
    decidedAt: z.string().nullable(),
    invoiceNumber: z.string().nullable(),
    createdByName: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    lines: z.array(QuoteLineDtoSchema),
});
export const QuoteListResponseSchema = z.object({
    items: z.array(QuoteListItemSchema),
    total: z.number().int(),
    page: z.number().int(),
    pageSize: z.number().int(),
});
// ---------- SMTP de la compañía ----------
export const FirmSmtpConfigSchema = z.object({
    smtpHost: z.string().max(255).nullable(),
    smtpPort: z.number().int().min(1).max(65535),
    smtpSecure: z.boolean(),
    smtpUser: z.string().max(255).nullable(),
    /** Solo escritura; el GET nunca devuelve la contraseña, solo si existe. */
    smtpPassword: z.string().max(255).nullable().optional(),
    smtpFromEmail: z.string().email().nullable(),
    smtpFromName: z.string().max(120).nullable(),
});
export const FirmSmtpStatusSchema = z.object({
    smtpHost: z.string().nullable(),
    smtpPort: z.number().int(),
    smtpSecure: z.boolean(),
    smtpUser: z.string().nullable(),
    hasPassword: z.boolean(),
    smtpFromEmail: z.string().nullable(),
    smtpFromName: z.string().nullable(),
});
//# sourceMappingURL=quotes.js.map